import {consent} from 'pageflow/frontend';
import {setup} from '../sourcepointConsent';

setup(consent);
